/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import * as Yup from 'yup'
import clsx from 'clsx'
import { useFormik } from 'formik'
import { login } from '../core/_requests'
import { useAuthStore } from 'Store/Auth'
import { useAppStore } from 'Store/App'
import { useLocation } from 'react-router-dom'
import { shallow } from 'zustand/shallow'
// import Styles.css
import './Styles.css'
const loginSchema = Yup.object().shape({
  email: Yup.string()
    .min(3, 'ต้องมีอย่างน้อย 3 ตัวอักษร')
    .max(50, 'สูงสุด 50 ตัวอักษร')
    .required('จำเป็นต้องระบุผู้ใช้'),
  password: Yup.string()
    .min(3, 'ต้องมีอย่างน้อย 3 ตัวอักษร')
    .max(50, 'สูงสุด 50 ตัวอักษร')
    .required('จำเป็นต้องระบุรหัสผ่าน'),
})

const initialValues = {
  email: '',
  password: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const location = useLocation()
  const [loading, setLoading] = useState(false)
  const setAccessToken = useAuthStore(state => state.setAccessToken, shallow)
  const setProfile = useAuthStore(state => state.setProfile, shallow)

  // @ts-ignore
  const prevPage = location?.state?.prevPage
  const setPrevPage = useAppStore(state => state.setPrevPage, shallow)

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      setStatus(null)
      try {
        const { data: auth } = await login(values.email, values.password)
        const { api_token, fullName, username, isVerify, permissions } = auth

        setAccessToken(api_token)
        setProfile({ fullName, username, isVerify, permissions })
      } catch (error) {
        setStatus('ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  useEffect(() => {
    if (prevPage) {
      setPrevPage(prevPage)
    } else {
      setPrevPage(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prevPage])

  return (
    <>
      <div className='d-flex flex-column flex-root login-bg'>
        <div className='d-flex flex-column flex-column-fluid flex-xl-row justify-content-center'>
          <div className='d-flex flex-center w-xl-50 p-10'>
            <div className='card rounded-3 w-xl-550px w-100'>
              <div className='card-body p-10 p-xl-20'>
                <form
                  className='form mx-auto'
                  onSubmit={formik.handleSubmit}
                  noValidate
                  id='kt_login_signin_form'>
                  <div className='text-center'>
                    <img
                      src='/media/paco/logo.jpeg'
                      style={{ height: '120px' }}
                      alt='Siam Kubota Logo TH language'
                    />
                  </div>

                  {formik.status && (
                    <div className='alert alert-danger mb-5'>
                      <div className='alert-text font-weight-bold'>{formik.status}</div>
                    </div>
                  )}

                  {/* <div className='text-center mb-11'>
                    <h1 className='text-dark fw-bolder mb-3'>Siam Kubota Metal</h1>
                  </div> */}

                  <div className='fv-row mb-8'>
                    <label className='form-label fs-6 fw-bolder text-dark'>ชื่อผู้ใช้งาน</label>
                    <input
                      placeholder=''
                      {...formik.getFieldProps('email')}
                      className={clsx(
                        'form-control bg-transparent',
                        {
                          'is-invalid':
                            (formik.touched.email && formik.errors.email) || formik.status,
                        },
                        {
                          'is-valid': formik.touched.email && !formik.errors.email,
                        }
                      )}
                      type='text'
                      name='email'
                      autoComplete='off'
                    />
                    {formik.touched.email && formik.errors.email && (
                      <div className='fv-plugins-message-container'>
                        <span role='alert'>{formik.errors.email}</span>
                      </div>
                    )}
                  </div>

                  <div className='fv-row mb-3'>
                    <label className='form-label fw-bolder text-dark fs-6 mb-0'>รหัสผ่าน</label>
                    <input
                      type='password'
                      autoComplete='off'
                      {...formik.getFieldProps('password')}
                      className={clsx(
                        'form-control bg-transparent',
                        {
                          'is-invalid':
                            (formik.touched.password && formik.errors.password) || formik.status,
                        },
                        {
                          'is-valid': formik.touched.password && !formik.errors.password,
                        }
                      )}
                    />
                    {formik.touched.password && formik.errors.password && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span role='alert'>{formik.errors.password}</span>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className='d-grid mb-10'>
                    {/* <Link to='/auth/forgot-password'>
                      <div className='text-end mb-5 text-gray-600 cursor-pointer text-decoration-underline'>
                        ลืมรหัสผ่าน?
                      </div>
                    </Link> */}

                    <button
                      type='submit'
                      id='kt_sign_in_submit'
                      className='btn btn-primary'
                      disabled={formik.isSubmitting || !formik.isValid}>
                      {!loading && <span className='indicator-label'>เข้าสู่ระบบ</span>}
                      {loading && (
                        <span className='indicator-progress' style={{ display: 'block' }}>
                          กำลังเข้าสู่ระบบ...
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
